import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		brand: {
			50: '#E6EEFC',
			100: '#C7DBFA',
			200: '#8FB6F0',
			300: '#4E88E4',
			400: '#1E63D6',
			500: '#0B4FD1',
			600: '#0A45B8',
			700: '#083A9C',
			800: '#052B5F',
			900: '#041E42'
		},
		brandScheme: {
			50: '#E6EEFC',
			100: '#C7DBFA',
			200: '#8FB6F0',
			300: '#4E88E4',
			400: '#1E63D6',
			500: '#0B4FD1',
			600: '#0A45B8',
			700: '#083A9C',
			800: '#052B5F',
			900: '#041E42'
		},
		cyan: {
			50: '#E6F6F9',
			100: '#B9E7EF',
			200: '#7FE3F0',
			300: '#3FCADD',
			400: '#22C3DE',
			500: '#0EA5C4',
			600: '#0E7A90',
			700: '#0B6274',
			900: '#04343C'
		},
		secondaryGray: {
			100: '#E0E5F2',
			200: '#E1E9F8',
			300: '#F4F7FE',
			400: '#E9EDF7',
			500: '#8F9BBA',
			600: '#A3AED0',
			700: '#707EAE',
			800: '#707EAE',
			900: '#1B2559'
		},
		red: {
			100: '#FEEFEE',
			500: '#EE5D50',
			600: '#E31A1A'
		},
		blue: {
			50: '#EFF4FB',
			500: '#3965FF'
		},
		orange: {
			100: '#FFF6DA',
			500: '#FFB547'
		},
		green: {
			100: '#E6FAF5',
			500: '#01B574'
		},
		navy: {
			50: '#d6e2fb',
			100: '#aac3fe',
			200: '#a3b9f8',
			300: '#728fea',
			400: '#1E63D6',
			500: '#1b3bbb',
			600: '#24388a',
			700: '#083A9C',
			800: '#052B5F',
			900: '#041E42'
		},
		gray: {
			100: '#FAFCFE'
		}
	},
	styles: {
		global: (props: any) => ({
			body: {
				overflowX: 'hidden',
				bg: mode('secondaryGray.300', 'navy.900')(props),
				fontFamily: 'DM Sans',
				letterSpacing: '-0.5px'
			},
			input: {
				color: 'gray.700'
			},
			html: {
				fontFamily: 'DM Sans'
			}
		})
	}
};
